import { render, staticRenderFns } from "./ProjectEditOptionBudgetsTab.vue?vue&type=template&id=6d12c111"
import script from "./ProjectEditOptionBudgetsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditOptionBudgetsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports